import { auth } from 'db/config';
import { registerUser, updateHandle } from 'services/users';
import {
  getAdditionalUserInfo,
  GoogleAuthProvider,
  signInWithPopup,
} from 'firebase/auth';

const googleProvider = new GoogleAuthProvider();

export async function signInWithGoogle() {
  try {
    const result = await signInWithPopup(auth, googleProvider);
    const user = result.user;

    const additionalInfo = getAdditionalUserInfo(result);
    const isNewUser = additionalInfo?.isNewUser;

    if (isNewUser) {
      await registerUser(user.uid, {
        displayName: user.displayName,
        email: user.email,
        firstName: user.displayName?.split(' ')[0]?.trim() || '',
        lastName: user.displayName?.split(' ')[1]?.trim() || '',
        photoURL: user.photoURL,
      });

      const isGmail = user.email?.endsWith('@gmail.com');
      if (isGmail) await updateHandle(user.email.split('@')[0]);
    } else {
      console.log(
        'Usuario existente ha iniciado sesión con Google:',
        user.displayName
      );
    }
    return user;
  } catch (error) {
    console.error('Error al iniciar sesión con Google:', error);
    //throw error;
  }
}
